module.exports = __webpack_public_path__ + "static/media/ar.17f44a67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dashboard-languages/ar.png
// module id = 936
// module chunks = 0